<template>
  <div
      class="VFeatureVirtualTable noselect"
      :class="tableClass"
  >

    <div class="header-table">
      <div
          class="VFeatureBlock-head"
      >
        <div class="VFeatureBlock-headers">
          <div
              class="VFeatureBlock-headers__name  "
              @click="filterByValue('nameColumn',-1,true)"
          >
                        <span
                            v-if="filterValue.name === 'nameColumn'"
                            class="VFeatureBlock-headers__filter-icon VFeatureBlock-headers__filter-icon-name"
                        >
                            <span
                                :class="{'VFeatureBlock-headers__filter-triangle-icon_descending': filterValue.sort==='descending'}"
                                class="VFeatureBlock-headers__filter-triangle-icon"
                            ></span>
                        </span>
            name
          </div>
          <template v-if="shortFeatureName === 'Summary'">
                    <span
                        class="VFeatureBlock-data-column"
                        v-for="(column) in additionalColumns"
                        :key="column.name"
                        @mouseover="showTooltip($event,'text',column.tooltip,column.name)"
                    >{{ column.title }}</span>
          </template>
          <div
              class="VFeatureBlock-data-column"
              v-for="(name,nameIndex) in showHeadersNames"
              @click="filterByValue(name,nameIndex,true)"
              :key="nameIndex"
          ><span
              v-if="name === filterValue.name"
              class="VFeatureBlock-headers__filter-icon"
          >
                        <span
                            :class="{'VFeatureBlock-headers__filter-triangle-icon_descending': filterValue.sort==='descending'}"
                            class="VFeatureBlock-headers__filter-triangle-icon VFeatureBlock-headers__filter-triangle-icon_columns"
                        >
                        </span>
                    </span>{{ name }}
          </div>
        </div>
      </div>
    </div>
    <div
        class="root"
        ref="root"
    >

      <div
          class="viewport "
          ref="viewport"
          :style="viewportStyle"
      >
        <div
        >
          <div
              class="spacer dedicated-table"
              ref="spacer"
              :style="spacerStyle"
          >
            <div
                class="VFeatureBlock-item__add"
                v-if="selectedIds.length > 1"
            >
              <div
                  class="VFeatureBlock-item__name"
                  @click="sumCalcRows"
              ><img
                  src="/icons/components/VFeatureBlock/icon_add-sum.svg"
                  alt="Settings"
              ></div>

            </div>
            <div
                class="VFeatureBlock-item"
                v-for="(row,rowIndex) in sumRows"
                :key="row.value"
            >
              <div class="row-sector">
              <div
                  class="VFeatureBlock-item__name VFeatureBlock-item-sum-row"
                  @click="deleteSumRow(rowIndex)"
              ><span class="VFeatureBlock-item-sum-row-img"><img
                  src="/icons/components/VFeatureBlock/icon_add-sum.svg"
                  alt="Settings"
              ></span><span class="VFeatureBlock-item-sum-row-text">{{ row.value }}</span></div>
              <div
                  class="VFeatureBlock-data-column"
                  v-for="(cell,cellIndex) in row.cells"
                  :key="cellIndex"
              >{{ cell }}</div>
              </div></div>

            <div
                class="VFeatureBlock-item"
                v-for="(row,rowIndex) in visibleItems"
                @mousedown="mousedown"
                @click="handleClick($event,row)"
                @contextmenu.prevent="selectAllRowExceptClicked($event,row)"
                :class="[row.color,`VFeatureBlock-${shortFeatureName}-${row.uniqueId}`,{'highlighted' :
                            summaryNotes[row.value]}]"
                :key="rowIndex"
            >
              <div class="row-sector">
                <div
                    class="VFeatureBlock-item__name"
                ><span v-if="row.namePrefix">{{ row.namePrefix }}</span>
                  <template v-if="shortFeatureName==='geo'">
                    <span v-if="row.areSubrowsLoading" @click.stop class="VFeatureBlock-item_clock-animation"><img
                        src="/icons/components/VFeatureBlock/icon_clock.gif"
                        alt="Clock"
                    ></span>
                    <span v-else @click.stop="addGeoData(rowIndex,row)" class="VFeatureBlock-item_button" :class="[row.areSubrowsOpen ? 'VFeatureBlock-item_opened' : 'VFeatureBlock-item_closed',{active:row.areSubrowsLoaded }]">&gt;</span>
                  </template>
                    {{ row.showName }}
                </div>
                <template v-if="shortFeatureName === 'Summary'">
                            <span
                                class="VFeatureBlock-data-column"
                                v-for="(column,columnIndex) in changedAdditionalColumns"
                                :key="column.name"
                                @click.stop
                            >
                                <VInput
                                    v-if="column.type==='input'"
                                    :value="getAdditionalColumnValue(column.data[row.value],row.value)"
                                    :min="0"
                                    :is-allow-fractional="true"
                                    type="number"
                                    :class="{'error-outline':checkArppuErrorClass(column, row, columnIndex),'default-outline':checkArppuDefaultClass(column, row, columnIndex)}"
                                    @input="updateAdditionalColumnValue($event, columnIndex, row.value)"
                                    @focus="additionalColumnFocus(columnIndex, row.value)"
                                >
                                </VInput>
                                <template v-else>
                                    {{
                                    column.data[row.value] != null && column.data[row.value] != '' ? column.data[row.value] : '—'
                                  }}
                                </template>
                            </span>
                </template>
                <div
                    class="VFeatureBlock-data-column"
                    v-for="(cell,cellIndex) in row.cells"
                    :key="cellIndex"
                >{{ cell }}</div>
              </div>
              <template    v-if="row.areSubrowsOpen">
              <div
                  class="row-sector VFeatureBlock-subrow-item"
                  v-for="(subrow,subrowIndex) in row.subrows"
                  :key="`${rowIndex}-${subrowIndex}`"
              >
                <div
                    class="VFeatureBlock-item__name"
                ><span v-if="subrow.namePrefix">{{ subrow.namePrefix }}</span>{{ subrow.showName }}
                </div>
                <div
                    class="VFeatureBlock-data-column"
                    v-for="(subcell,subcellIndex) in subrow.cells"
                    :key="`${rowIndex}-${subcellIndex}`"
                >{{ subcell }}</div>
              </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {removeSelection} from '../../helpers/domHelper';
import {ResizeObserver} from '@juggle/resize-observer';

export default {
  name: 'VFeatureVirtualTable',
  props: {
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    itemsChanges: {
      type: Object,
      required: false,
      default: () => {
      },
    },
    sumRows: {
      type: Array,
      required: true,
    },
    selectedIds: {
      type: Array,
      required: true,
    },
    showHeadersNames: {
      type: Array,
      required: true,
    },
    additionalColumns: {
      type: Array,
      required: false,
    },
    changedAdditionalColumns: {
      type: Array,
      required: false,
    },
    summaryNotes: {
      type: Object,
      required: false,
    },
    feature: {
      type: Object,
      required: false,
    },
    currentBoard: {
      type: Object,
      required: false,
    },
    featureSettings: {
      type: Object,
      required: false,
    },
    filterValue: {
      type: Object,
      required: false,
    },
    isSumPlusVisible: {
      type: Boolean,
      required: false,
    },
    featureIndex: {
      type: Number,
      required: true,
    },
    shortFeatureName: {
      type: String,
      required: true,
    },
    itemsCount: {
      type: Number,
      default: 20,
    },
    isLoadedFromPopup: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      row: {
        height: 29,
      },
      scrollTop: 0,
      nodePadding: 2,
      visibleItems: [],
      tableClass: '',
      isFirstClickInput: false,
      offsetOld: 0,
      itemCount: 0,
    };
  },
  watch: {
    items: {
      deep: false,
      immediate: true,
      handler() {
        this.getVisibleItems();
        this.recalcItemCount();
        this.$nextTick(()=>{
          this.updateScrollableClass();
        })
      },
    },
    sumRowsLength: {
      deep: false,
      immediate: true,
      handler() {
        this.recalcItemCount();
      },
    },
    isSumPlusVisible: {
      deep: false,
      immediate: true,
      handler() {
        this.recalcItemCount();
      },
    },
    itemsChanges: {
      deep: true,
      immediate: true,
      handler() {
        this.getVisibleItems();
      },
    },
  },
  computed: {
    offsetNew(){
      let totalHeight = 0;
      for (let i = 0; i < this.startIndex; i++) {
        totalHeight += this.row.height;
        if (this.items[i].areSubrowsOpen) {
          totalHeight += this.items[i].subrows.length * this.row.height;
        }
      }
      return totalHeight;
    },
    viewportHeight() {
      return this.itemCount * this.row.height;
    },
    startIndex() {
      const node = this.calculateScrolledNode();
      let startNode = node - this.nodePadding;
      startNode = Math.max(0, startNode);
      return startNode;
    },
    visibleNodeCount() {
      return this.itemsCount + this.sumRowsLength + Number(this.isSumPlusVisible);
    },
    sumRowsLength() {
      return this.feature.sumRows.length;
    },
    spacerStyle() {
      return {
        transform: 'translateY(' + this.offsetNew + 'px)',
      };
    },
    viewportStyle() {
      return {
        height: this.viewportHeight + 'px',
      };
    },
  },
  methods: {
    recalcItemCount(){
      let itemCount = 0;
      for (let i = 0; i < this.items.length; i++) {
        itemCount++;
        if (this.items[i].areSubrowsOpen) {
          itemCount += this.items[i].subrows.length;
        }
      }

      this.itemCount  = itemCount + this.sumRowsLength + Number(this.isSumPlusVisible);
    },
    addGeoData(rowIndex,row){
      const itemsRow = this.items.find((item)=> item.uniqueId === row.uniqueId);
      const featureRow = this.feature.rows.find((item)=> item.uniqueId === row.uniqueId);
      if (!itemsRow.subrows.length) {
        itemsRow.areSubrowsOpen = true;
        itemsRow.areSubrowsLoading = true;
        itemsRow.areSubrowsLoaded = false;
        this.$emit('addGeoData', itemsRow);
      }
      else {
        if(this.filterValue.name === ''){
          row.areSubrowsOpen = !row.areSubrowsOpen;
        }
        else{
          itemsRow.areSubrowsOpen = !itemsRow.areSubrowsOpen;
          featureRow.areSubrowsOpen = !featureRow.areSubrowsOpen;
        }
      }
      this.recalcItemCount();
      this.getVisibleItems();
    },
    calculateScrolledNode() {
      let cumulativeHeight = 0;
      let totalRowsScrolled = 0;
      let offset = 0;
      let previousOffest = 0;
      for (let i = 0; i < this.items.length; i++) {
        cumulativeHeight += this.row.height;
        totalRowsScrolled++;

        if (this.scrollTop < cumulativeHeight) {
          this.offsetOld = previousOffest;
          return totalRowsScrolled - 1;
        }

        if (i >= this.nodePadding) {
          offset += this.row.height;
        }
        if (this.items[i].areSubrowsOpen) {
          for (let j = 0; j < this.items[i].subrows.length; j++) {
            cumulativeHeight += this.row.height;
            if (i >= this.nodePadding) {
              offset += this.row.height;
            }
            if (this.scrollTop < cumulativeHeight) {
              this.offsetOld = previousOffest;
              return totalRowsScrolled - 1;
            }
          }
        }
        previousOffest = offset;
      }
      this.offsetOld = offset;
      return totalRowsScrolled - 1;
    },
    checkArppuErrorClass(column, row, columnIndex) {
      return (!column.data[row.value] &&
              !!this.additionalColumns[columnIndex].data[row.value])
          || (this.additionalColumns[columnIndex].data[row.value] !== column.data[row.value]);
    },
    checkArppuDefaultClass(column, row) {
      return this.currentBoard.tempData.arrpusDefault[row.value] && column.data[row.value] &&
          this.currentBoard.tempData.arrpusDefault[row.value] !== column.data[row.value];
    },
    showTooltip(event, tooltipFunction, data, name) {
      if (name === 'pROMI') {
        const koef = this.currentBoard.arppuCoef ? '0.85' : '0.7';
        const text = `100 * ((ARPPU * activations * ${koef}) - expense) / expense `;
        this.$emit('showTooltip', event, tooltipFunction, text);
      } else if (data) {
        this.$emit('showTooltip', event, tooltipFunction, data);
      }
    },
    getAdditionalColumnValue(savedValue, columnName) {
      if (savedValue) {
        return savedValue;
      }
      if (this.currentBoard.tempData.arrpusDefault[columnName]) {
        this.currentBoard.tempData.arrpusDefault[columnName];
        return this.currentBoard.tempData.arrpusDefault[columnName];
      }
      return '0';
    },
    updateAdditionalColumnValue(value, columnIndex, name) {
      this.$emit('updateChangedAdditionalColumns', value, columnIndex, name);
    },
    additionalColumnFocus(columnIndex, name) {
      if (this.currentBoard.tempData.arrpusDefault[name] && this.additionalColumns[columnIndex].data[name] &&
          this.additionalColumns[columnIndex].data[name] !== this.currentBoard.tempData.arrpusDefault[name]) {
        this.$emit('setCurrentArppuColumn', {
          columnIndex,
          name,
        });
      } else {
        this.$emit('setCurrentArppuColumn', {
          columnIndex: null,
          name: '',
        });
      }
    },
    updateScrollableClass() {
      const element = this.$el.querySelector('.root');
      this.tableClass = element.scrollHeight > element.clientHeight ? 'scrollable' : 'non-scrollable';
    },
    getVisibleItems() {
      const items = [];
      const itemsLength = Math.min(this.visibleNodeCount, this.items.length, this.items.length - this.startIndex);
      for (let i = 0; i < itemsLength; i++) {
        const item = this.items[this.startIndex + i];
        items[i] = Object.assign(item, this.itemsChanges[item.uniqueId]);
      }
      this.visibleItems = Object.freeze(items);
    },
    handleScroll() {
      this.scrollTop = this.$refs.root.scrollTop;
      this.getVisibleItems();
      removeSelection();
    },
    mousedown(event) {
      this.isFirstClickInput = event.target.tagName === 'INPUT';
    },
    handleClick(event, row) {
      if (!this.isFirstClickInput) {
        if (!event.shiftKey && !event.ctrlKey && !event.metaKey) {
          this.filterClickedRow(row, 'equal');
        } else if (event.shiftKey && event.metaKey && !event.ctrlKey) {
          this.filterClickedRow(row, 'sub');
        } else if (!event.shiftKey && (event.ctrlKey || event.metaKey)) {
          this.selectRow(row);
        } else if (event.shiftKey && !event.ctrlKey && !event.metaKey) {
          this.selectRowWithShift(row);
        }
      }
      this.isFirstClickInput = false;
    },
    selectRow(row) {
      this.$emit('selectRow', row);
    },
    selectAllRowExceptClicked(event, row) {
      event.preventDefault();
      this.$emit('selectAllRowExceptClicked', row);
    },
    selectRowWithShift(row) {
      const rowIndex = this.items.findIndex((item) => item.uniqueId === row.uniqueId);
      this.$emit('selectRowWithShift', row, rowIndex);
    },
    sumCalcRows() {
      this.$emit('sumRows', this.featureIndex);
    },
    filterClickedRow(row, filterType) {
      this.$emit('filterClickedRow', row, filterType);
    },
    filterByValue(name, index, change = false) {
      this.$emit('filterByValue', name, index, change);
    },
    deleteSumRow(index) {
      this.$emit('deleteSumRow', index);
    },
  },
  mounted() {
    this.$refs.root.addEventListener(
        'scroll',
        this.handleScroll,
        {passive: true},
    );
    this.tableClass = this.visibleItems.length > 12 ? 'scrollable' : 'non-scrollable';
    if (this.isLoadedFromPopup) {
      const element = this.$el.querySelector('.root');
      new ResizeObserver(this.updateScrollableClass).observe(element);
    }
  },
  beforeDestroy() {
    this.$refs.root.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style
    scoped
    lang="scss"
>
.scrollable {
  .VFeatureBlock-headers {
    padding: 0 21px 0 10px;
  }
}

.VFeatureBlock-data-column, .VFeatureBlock-item__name {
  border: 1px solid transparent;
}

.VFeatureBlock {
  .VFeatureVirtualTable {
    overflow-x: hidden;
    margin-top: 10px;
    @include only_firefox('.VFeatureBlock-headers', (
        display: flex,
    ));
    @include only_safari('.VFeatureBlock-headers', (
        display: flex,
    ));

    .root {
      max-height: 351px;
      font-family: 'Nunito', sans-serif;
      font-size: 12px;
      letter-spacing: 0;
      line-height: 19px;
      text-align: center;
      font-weight: 400;
      display: block;
      overflow-y: auto;
      margin-bottom: 10px;
      @include scrollbar-styles;
    }

    .viewport {
      overflow: hidden;
      position: relative;
    }

  }

  &-head {
    position: relative;
    z-index: 7;
  }

  &-headers {
    font-family: 'Nunito', sans-serif;
    font-size: 11px;
    letter-spacing: 0;
    line-height: 11px;
    height: 15px;
    padding: 0 10px 0 10px;
    margin-bottom: 5px;

    &__name {
      overflow: hidden;
      text-overflow: ellipsis;
      position: sticky;
      top: 0;
      text-align: left;
      cursor: pointer;
      z-index: 4;
      padding-left: 10px;
      flex-grow: 1;
    }

    .VFeatureBlock-data-column {
      cursor: pointer;
      position: sticky;
      top: 0;
      min-width: 36px;
      text-align: right;
      z-index: 4;
    }

    .VFeatureBlock-data-column {
      cursor: pointer;
      position: sticky;
      top: 0;
      min-width: 36px;
      text-align: right;
      z-index: 4;
    }

    &__filter-icon {
      position: relative;
      height: 5px;
      width: 3px;
      display: inline-block;

      &-name {
        position: absolute;
        left: 4px;
        top: 4px;
      }
    }

    &__filter-triangle-icon {
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 2.5px 5px 2.5px;
      border-color: transparent transparent #00cd96 transparent;
      position: absolute;

      &_columns {
        right: 1px;
      }

      &_descending {
        transform: rotate(
                180deg
        );
      }

    }
  }

  &-subrow-item {
    div{
      border-top: none!important;
      border-bottom: none!important;
    }
    .VFeatureBlock-item__name {
      //visibility: hidden;
      padding-left: 19px;
      span{
        left:25px!important;
      }
    }
  }
  &-subrow-item{
    font-size: 10px;
  }

  &-item {
    .row-sector {
      height: 29px;
      line-height: 27px;
      cursor: pointer;
      padding: 0 10px 0 20px;
      display: flex;
      background: none!important;
      border: none!important;
    }
    @import "selectColorsInRows";


    &.highlighted {
      .VFeatureBlock-item__name {
        span {
          color: $primary-color;
          opacity: 1;
          font-weight: 700;
        }
      }
    }


    &__add {
      cursor: pointer;
      height: 29px;

      img {
        position: absolute;
        top: 5px;
        left: 20px;
      }
    }

    &_clock-animation{
      left: 2px!important;
      img {
        height: 20px;
        position: relative;
        width: 20px;
        top: 2px;
      }
    }

    &_button{
      cursor: pointer;
      height: 24px;
      width: 15px;
      display: inline-block;
      text-align: center;
      line-height: 24px;
      font-weight: 700;
      font-size: 15px !important;
    }

    &_opened, &_closed {
      color: gray!important;

      &.active{
        color: #41ff00 !important;
        opacity: 1!important;
        font-weight: 700!important;
      }
    }


    &_opened {
      left:4px!important;
      transform: rotate(-90deg);
    }

    &_closed {
      transform: rotate(90deg);
    }

    &__name {
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: left;
      white-space: nowrap;
      flex-grow: 1;

      span {
        display: inline-block;
        font-size: 9px;
        /* width: 21px; */
        color: black;
        opacity: 0.6;
        position: absolute;
        left: 5px;
      }
    }

    &-sum-row {
      &-img {

        img {
          transform: rotate(
                  -45deg
          );
          height: 13px;
          position: relative;
          width: 13px;
          top: 2px;
        }
      }

      &-text {
        padding-left: 15px;
        font-weight: bold;
        line-height: 22px;
        text-transform: uppercase;
      }
    }

    .VFeatureBlock-data-column {
      text-align: right;
      min-width: 36px;
      font-size: 12px;
      flex-shrink: 0;

      ::v-deep {
        input {
          width: 28px !important;
          height: 22px;
          padding-left: 5px;
        }

        .VInput-wrapper {
          height: 26px;
        }
      }
    }

    .VFeatureBlock-data-column {
      text-align: right;
      min-width: 36px;
      font-size: 12px;
      flex-shrink: 0;

      &:empty {
        &::after {
          content: "\2014";
          display: block;
          text-align: right;
          font-size: 12px;
        }
      }

    }
  }

}


@supports (-moz-appearance:none) {
  .VFeatureBlock-headers-background {
    width: calc(100% - 7px);

    &-border {
      left: 7px;
      width: calc(100% - 14px);
    }
  }
}
</style>
